__turbopack_context__.v({
  "button": "Popup-module__ZuI85W__button",
  "buttonDanger": "Popup-module__ZuI85W__buttonDanger",
  "buttonError": "Popup-module__ZuI85W__buttonError",
  "buttonInfo": "Popup-module__ZuI85W__buttonInfo",
  "buttonOutline": "Popup-module__ZuI85W__buttonOutline",
  "buttonPrimary": "Popup-module__ZuI85W__buttonPrimary" + " " + "Popup-module__ZuI85W__button",
  "buttonRow": "Popup-module__ZuI85W__buttonRow",
  "buttonSecondary": "Popup-module__ZuI85W__buttonSecondary",
  "buttonSuccess": "Popup-module__ZuI85W__buttonSuccess" + " " + "Popup-module__ZuI85W__button",
  "buttonText": "Popup-module__ZuI85W__buttonText",
  "chip": "Popup-module__ZuI85W__chip",
  "closeBtn": "Popup-module__ZuI85W__closeBtn",
  "desc": "Popup-module__ZuI85W__desc",
  "iconCircle": "Popup-module__ZuI85W__iconCircle",
  "iconDanger": "Popup-module__ZuI85W__iconDanger",
  "iconError": "Popup-module__ZuI85W__iconError",
  "iconInfo": "Popup-module__ZuI85W__iconInfo",
  "iconMinimal": "Popup-module__ZuI85W__iconMinimal",
  "iconSuccess": "Popup-module__ZuI85W__iconSuccess",
  "modal": "Popup-module__ZuI85W__modal",
  "overlay": "Popup-module__ZuI85W__overlay",
  "popupIn": "Popup-module__ZuI85W__popupIn",
  "title": "Popup-module__ZuI85W__title",
  "titleDanger": "Popup-module__ZuI85W__titleDanger" + " " + "Popup-module__ZuI85W__title",
  "warningText": "Popup-module__ZuI85W__warningText",
});
